import React from "react";
import styled from "styled-components";
import { useAntTheme } from "@/hooks/useAntTheme";
import {
  STATIC_PALETTES,
  type StatCardColor,
  type StatCardPalette,
} from "pages/media/components/analytics/analyticsTheme";
import { Card, Typography } from "antd";

export type InsightMetricCardProps = {
  /** Pre-formatted value — a number or a string like "18 / 20". */
  value: React.ReactNode;
  label: string;
  color: StatCardColor;
};

export const InsightMetricCard: React.FC<InsightMetricCardProps> = ({
  value,
  label,
  color,
}) => {
  const { theme } = useAntTheme();

  const palette: StatCardPalette =
    color === "green"
      ? {
          accent: theme.colorPrimary,
          value: theme.colorPrimary,
          iconBg: theme.colorPrimaryBgHover,
        }
      : STATIC_PALETTES[color];

  return (
    <StyledCard
      $accent={palette.accent}
      styles={{ body: { padding: "12px 14px" } }}
    >
      <Typography.Title level={4} style={{ color: palette.value, margin: 0 }}>
        {value}
      </Typography.Title>
      <Typography.Text style={{ fontSize: 12, color: theme.colorGrey }}>
        {label}
      </Typography.Text>
    </StyledCard>
  );
};

// ─── Styled components ───

const StyledCard = styled(Card)<{ $accent: string }>`
  height: 100%;
  border-left: 3px solid ${({ $accent }) => $accent};
`;
